
defsPackEditor.title.placeholder=Masukkan judul (tema atau sesuatu)
defsPackEditor.description.placeholder=Masukkan deskripsi
defsPackEditor.title.create=Buat kartu flash baru
defsPackEditor.title.save=Edit kartu flash
defsPackEditor.addPackImage=Tambahkan gambar
visibility.label=Terlihat oleh
visibility.0=Hanya aku
visibility.1=Semua orang (setelah memeriksa)
visibility.2=Verifikasi
visibilityBadge.0=Pribadi
visibilityBadge.1=Publik
visibilityBadge.2=Verifikasi
## не удаляйте этот блок, на него есть ссылки в {plurals}
pl.card.one=kartu
pl.card.few=kartu-kartu
pl.card.other=kartu-kartu
pl.day.one=hari
pl.day.few=hari
pl.day.other=hari
pl.passedReview.one=lulus tinjauan
pl.passedReview.few=ulasan yang lulus
pl.passedReview.other=ulasan yang lulus
pl.failedReview.one=ulasan gagal
pl.failedReview.few=ulasan gagal
pl.failedReview.other=ulasan gagal
pl.freshCard.one=kartu baru
pl.freshCard.few=kartu baru
pl.freshCard.other=kartu baru
pl.hours.one=jam
pl.hours.few=jam
pl.hours.other=jam
pl.hours={0} {0,plural,one{jam}few{jam}other{jam}}
pl.days.one=hari
pl.days.few=hari
pl.days.other=hari
pl.days={0} {0,plural,one{hari}few{hari}other{hari}}
pl.minutes.one=menit
pl.minutes.few=menit
pl.minutes.other=menit
pl.minutes={0} {0,plural,one{menit}few{menit}other{menit}}
## validation
rubd.flashcards.services.validation.SideTextWhenCardIsNotEmpty.message=Kartu tidak kosong, Anda memerlukan beberapa teks untuk sisi ini
##
button.save=Menyimpan
button.saveContinue=Simpan dan lanjutkan
button.create=Membuat
button.cancel=Membatalkan
button.clone=Klon
button.print=Mencetak
button.checkTest=Periksa hasil
button.yes=Ya
button.close=Menutup
button.ok=Oke
button.help=Membantu
##
title.label=Judul
title.description=Keterangan
title.optional=(opsional)
## duration messages
fl.agoString={0} yang lalu
fl.agoRecently=Baru-baru ini
fl.timeSpent={0} dihabiskan
fl.timeSpentLessThanMinute=Menghabiskan sedikit
##
pack.cardCount={0} kartu
pack.cardCount.one=kartu {0}
pack.cardCount.many={0} kartu
pack.cardCount.few={0} kartu
##
page.defaultTitle=Kartu Flash Online
## user private dashboard
fl.mainDashboard.packAgo.title=Waktu yang telah berlalu sejak kunjungan terakhir
fl.mainDashboard.packSpent.title=Waktu yang dihabiskan untuk belajar
fl.mainDashboard.hideMemoPack=Set ini akan dihapus dari Dasbor Pembelajaran Jangka Panjang. Untuk menambahkannya kembali, Anda perlu mengeklik "Mulai belajar" di halaman set.
##
packEditor.form.termLanguage=Istilah bahasa
packEditor.form.termLanguage.placeholder=Pilih bahasa
packEditor.form.definitionLanguage=Bahasa definisi
packEditor.form.definitionLanguage.placeholder=Pilih bahasa
packEditor.form.loading=Memuat daftar kartu...
packEditor.form.cardMinimum=Harap isi setidaknya dua kartu flash
packEditor.importer.open=Impor dari txt, Word, Excel, Google Docs, dll.
packEditor.importer.close=Menutup
packEditor.importer.import=Impor
packEditor.importer.textLabel=Salin dan tempel teks di sini (dari Word, Excel, Google Docs, dll)
packEditor.importer.textPlaceholder=Kata 1    Definisi 1\nKata 2    Definisi 2\nKata 3    Definisi 3
packEditor.importer.result={0} entri telah diimpor
packEditor.importer.preview.title=Pratinjau kartu
packEditor.importer.preview.empty=Tidak ada kartu yang dikenali. Periksa pengaturan impor di panel kanan.
packEditor.anki.button=Impor Anki
packEditor.anki.dialog.message=Unggah file .APKG Anda untuk mengimpor setumpuk kartu flash ANKI Anda.
packEditor.anki.dialog.notice1=Beberapa dek tidak dapat diimpor atau mungkin diimpor dengan kesalahan. Hal ini tergantung pada struktur dek. Mohon maaf atas hal tersebut.
packEditor.anki.dialog.notice2=Anda dapat mengimpor dek Anda sendiri atau dek yang berhak Anda salin dan modifikasi.
packEditor.anki.dialog.title=Impor kartu flash Anki
packEditor.anki.dialog.button=Jelajahi
packEditor.anki.progress.sending=Mengirim berkas...
packEditor.anki.progress.parsing=Mengurai berkas...
packEditor.anki.progress.forming=Memasukkan hasil ke dalam formulir...
packEditor.anki.progress.error=Impor gagal.
packEditor.anki.progress.success=Operasi selesai. Kartu baru telah ditambahkan ke daftar di bawah ini.
packEditor.addRow=Tambahkan kartu
packEditor.card.term.placeholder=Ketentuan
packEditor.card.term.needText=Butuh teks di sini
packEditor.card.def.placeholder=Definisi
packEditor.card.def.needText=Butuh teks di sini
packEditor.importer.form.mode=Mode impor
packEditor.importer.form.mode.everyLine=Istilah dan definisi ada di setiap baris, dipisahkan oleh pembatas
packEditor.importer.form.mode.lineByLine=Istilah dan definisi berurutan, satu elemen per baris
packEditor.importer.form.everyLine1=Pembatas entri (baris)
packEditor.importer.form.everyLine2=Pembatas istilah/definisi
packEditor.importer.form.everyLine3=Opsi tambahan
packEditor.importer.form.ldLine=Pembungkus garis
packEditor.importer.form.ldDoubleLine=Bungkus garis ganda
packEditor.importer.form.ldCustom=Simbol khusus
packEditor.importer.form.ldJoinLowercase=Gabung baris yang dimulai dengan simbol huruf kecil
packEditor.importer.form.tdDash=Tanda hubung (-)
packEditor.importer.form.tdTab=Tab
packEditor.importer.form.tdCustom=Simbol khusus
packEditor.importer.form.lineByLine1=Opsi tambahan
packEditor.importer.form.llDoubleLine=Pembungkusan garis ganda di antara setiap grup
packEditor.importer.form.llJoinLowercase=Gabung baris yang dimulai dengan simbol huruf kecil
packEditor.splitNewCards.notice=Sepertinya Anda punya banyak kartu. Mungkin ada baiknya membagi kartu menjadi beberapa set.
packEditor.splitNewCards.checkbox.1=Ya, pisahkan kartu menjadi
packEditor.splitNewCards.checkbox.2=potongan di setiap set
packEditor.splitNewCards.shuffle=Dan kocok kartu sebelum dibagi
packEditor.splitNewCards.suffix=Bagian {0}.
packEditor.putToCollection=Tambahkan paket ke
packEditor.putToCollection.none=<tidak ada>
packEditor.putToCollection.createNew=koleksi atau {0}buat baru{1}.
packEditor.images.search=Cari gambar
packEditor.images.search.or=atau
packEditor.images.upload=Mengunggah
packEditor.images.remove=Hapus Gambar
packEditor.images.emptySearch=Tidak ada gambar yang ditemukan. Coba kueri lain.
packEditor.audio.record=Catatan
packEditor.audio.remove=Menghapus
packEditor.audio.upload=Mengunggah
##
collectionForm.modal.title=Buat koleksi baru
collectionForm.name=Nama
collectionForm.name.placeholder=Nama koleksi tipe
collectionForm.description=Keterangan
collectionForm.description.placeholder=Deskripsi koleksi tipe
##
myPage.title.author=Set milik saya sendiri
myPage.title.lastPacks=Set terakhirku
myPage.title.favourite=Set favoritku
myPage.empty.last=Anda belum mengunjungi set apa pun
myPage.empty.author=Anda belum membuat set apa pun
myPage.empty.favourite=Daftar favorit Anda kosong
##
packPage.header.from=oleh
packPage.buttonGroup.play=Bermain
packPage.button.play=Pratinjau
packPage.button.test=Tes
packPage.button.learn=Mempelajari
packPage.button.write=Menulis
packPage.button.spell=Mengeja
packPage.button.match=Cocok
packPage.button.live=Hidup
packPage.solw.short=Pembelajaran cepat
packPage.solw.short.subtitle=Ulangi rangkaian kartu flash ini
packPage.solw.short.new=Baru:
packPage.solw.short.familiar=Akrab:
packPage.solw.short.mastered=Menguasai:
packPage.solw.long=Pembelajaran Jangka Panjang
packPage.solw.long.subtitle=Pengulangan Berjarak
packPage.solw.long.today=Tugas hari ini
packPage.solw.long.new=Baru:
packPage.solw.long.review=Untuk meninjau:
packPage.button.memo=Memo
ppp0.title=Ingin mempelajari set ini dengan cepat?
packPage.dialogs.forbidden.alert=Hanya tersedia untuk pengguna yang berwenang
packPage.dialogs.forbidden.addToCollection.text=Anda dapat menambahkan set ini ke salah satu koleksi Anda
packPage.dialogs.forbidden.addToCollection.alert=Hanya tersedia untuk pengguna yang berwenang
packPage.dialogs.forbidden.createNew.title=Selamat datang!
packPage.dialogs.forbidden.createNew.text=Hanya pengguna yang berwenang yang dapat membuat kartu baru.
packPage.dialogs.forbidden.clone.text=Jika Anda menggunakan kartu-kartu ini untuk belajar, tetapi Anda ingin melengkapinya, klon saja dan buat set baru yang Anda perlukan.
packPage.dialogs.forbidden.clone.alert=Hanya tersedia untuk pengguna yang berwenang
packPage.dialogs.addToCollection.title=Tambahkan set ini ke koleksi
packPage.dialogs.addToCollection.notice=Anda dapat menambahkan set kartu flash ini ke koleksi belajar Anda
packPage.dialogs.addToCollection.createNew=+ Tambahkan Koleksi Baru
packPage.dialogs.addToCollection.forbidden=Hanya pengguna resmi yang dapat menambahkan kartu ke kursus mereka
packPage.dialogs.addToFavourites.title=Tambahkan set ini ke yang disimpan
packPage.dialogs.addToFavourites.forbidden=Anda dapat menambahkan simpan set ini untuk kembali lagi nanti
packPage.dialogs.login=Masuk / daftar
packPage.dialogs.share.title=Bagikan set ini
packPage.dialogs.clone.title=Kloning set ini
packPage.dialogs.clone.notice=Jika Anda menggunakan kartu-kartu ini untuk belajar, tetapi Anda ingin melengkapinya, klon saja dan buat set baru yang Anda perlukan.
packPage.command.edit=Sunting
packPage.command.customize=Sesuaikan
packPage.command.addTo=Tambahkan ke ...
packPage.command.addTo.collection=koleksi
packPage.command.addTo.saved=disimpan
packPage.command.share=Membagikan
packPage.list.sorting.original=Asli
packPage.list.sorting.alphabetical=Alfabetis
packPage.list.filter.all=Tampilkan semua
packPage.list.filter.difficult=Sulit
packPage.list.filter.banned=Diabaikan
packPage.list.filter.mastered=Dikuasai
packPage.list.filter.familiar=Akrab
packPage.list.filter.starred=Berbintang
packPage.list.emptyMessage=Tidak ada kartu yang sesuai dengan filter ini
packPage.list.loadMore=Lihat lebih banyak kartu
packPage.review=Tinjauan
packPage.startMemo=Tambahkan ke Meja Pembelajaran Jangka Panjang
packPage.startLearning=Mulai belajar
packPage.speedReview=Tinjauan kecepatan
packEmbed.clickToFlip=Klik untuk membalik
packPage.tooltips.memoShort=Mode pembelajaran cepat berguna saat Anda perlu mengulang beberapa kata atau pertanyaan sebelum ujian. Cocok untuk kumpulan kata yang sedikit.
packPage.tooltips.memoLong=Mode pembelajaran pengulangan spasi didasarkan pada metode pengulangan interval. Mode ini berguna untuk persiapan ujian sistematis dan pendidikan jangka panjang.
packPage.tooltips.preview=Lihat semua set kartu tanpa perlu mengendalikan diri.
packPage.tooltips.test=Buatlah tes untuk memeriksa pengetahuan Anda pada satu set kartu.
packPage.tooltips.spell=Pemeriksa ejaan. Tes mendengarkan dan menulis.
##
packPlay.back=Kembali
packPlay.options=Pilihan
packPlay.progress=Kemajuan
packPlay.progressTemplate={0} dari {1}
packPlay.wrongDisplay.title=Jawaban yang salah
packPlay.wrongDisplay.label=Jawaban yang benar
packPlay.wrongDisplay.continueText=Tekan tombol apa saja untuk melanjutkan
packPlay.wrongDisplay.userLabel=Kamu menulis
packPlay.wrongDisplay.typeText=Ketik jawaban yang benar di bawah ini
##
packLearn.remaining=Tersisa
packLearn.familiar=Akrab
packLearn.mastered=Dikuasai
packLearn.write.placeholder=tulis jawabanmu disini
packLearn.write.placeholderCopy=salin jawaban yang benar di sini
packLearn.write.submit=Menjawab
packLearn.write.skip=Melewati
packLearn.write.stillCorrect=aku benar
packLearn.write.giveup=Menyerah
packLearn.dialogs.options.title=Pilihan
packLearn.dialogs.options.questionTitle=Jawab dengan
packLearn.dialogs.options.questionTerm=Ketentuan
packLearn.dialogs.options.questionDefinition=Definisi
packLearn.dialogs.options.questionError=Setidaknya satu kotak centang harus dicentang
packLearn.dialogs.options.modeTitle=Jenis pertanyaan
packLearn.dialogs.options.modeSelect=Pilihan ganda
packLearn.dialogs.options.modeWrite=Tertulis
packLearn.dialogs.options.modeError=Setidaknya satu kotak centang harus dicentang
packLearn.dialogs.options.modeRandom=Urutan acak
packLearn.dialogs.options.resetTitle=Setel ulang kemajuan
packLearn.dialogs.options.resetButton=Mengatur ulang
packLearn.dialogs.options.modeCards=Kartu Flash
packLearn.dialogs.config.title=Opsi memo
packLearn.dialogs.firstTime.title=Pengaturan pertama kali
packLearn.dialogs.firstTime.notice=Anda dapat mengubah pengaturan ini di menu "Opsi" kapan saja
packLearn.dialogs.options.writeAnyAnswer=Tulis jawaban apa saja
packLearn.dialogs.options.writeAnyAnswer.notice=Anda hanya dapat menuliskan satu jawaban yang tersedia (dipisahkan dengan koma).
packLearn.dialogs.options.playAudio=Putar audio
packLearn.dialogs.options.newLimit=Batas kartu baru
packLearn.dialogs.options.newLimitError=Harus berupa angka positif, kurang atau sama dengan 50
packLearn.dialogs.options.order=Urutan baru
packLearn.dialogs.options.order.original=Asli
packLearn.dialogs.options.order.random=Acak
packLearn.dialogs.options.advancedMode=Mode lanjutan
packLearn.dialogs.options.advancedMode.notice=Secara default, "pembelajaran jangka panjang" menggunakan algoritma pengulangan jarak belajar yang dimodifikasi, di mana Anda cukup memilih "Tahu" atau "Tidak tahu". Dengan beralih ke "Mode lanjutan", Anda dapat menggunakan algoritma klasik dengan lima pilihan yang tersedia, mirip dengan Supermemo atau Anki.
##
searchPage.title=Cari "{0}"
searchPage.head=Hasil untuk kueri "{0}"
searchPage.display.packs=Set pertunjukan
searchPage.display.courses=Tampilkan kursus
searchPage.noResults.packs=Maaf, tidak ada set yang ditemukan
searchPage.noResults.courses=Maaf, tidak ada kursus yang ditemukan
##
learnPage.progress.total=Lulus
learnPage.progress.correct=Benar
learnPage.progress.wrong=Salah
learnPage.answer.go=Menjawab
learnPage.answer.placeholder=Ketik jawaban Anda
learnPage.answer.unknown=Saya tidak tahu
learnPage.wrong.stillCorrect=Jawaban saya benar!
learnPage.next=Berikutnya
learnPage.result.actual=Jawaban Anda
learnPage.result.correct=Jawaban yang benar
learnPage.header.correct=Jawaban yang benar
learnPage.header.wrong=Jawaban yang salah
learnPage.emptyQueue=Selamat! Kamu sudah melewati semua kartu.
learnPage.restartQueue=Mulai ulang
learnPage.reviewComplete.title=Selamat!
learnPage.reviewComplete.text=Anda telah memberikan semua kartu.
##
testSelectPage.opt.limit=Batasan pertanyaan
testSelectPage.opt.first=Menunjukkan
testSelectPage.start=Mulai pengujian
testSelectPage.opt.limit.prefix=Menggunakan
testSelectPage.opt.limit.suffix=dari {0}
testSelectPage.opt.first.face=Ketentuan
testSelectPage.opt.first.back=Definisi
testSelectPage.mode1=Cocok
testSelectPage.mode2=Ya / Tidak
testSelectPage.mode3=4 pilihan
testSelectPage.mode4=Menulis
##
testResult.message=Skor Anda:
testResult.correctTitle=Jawaban yang diharapkan
testResult.noAnswer=Anda tidak memilih apa pun
testResult.noAnswerWrite=Kamu tidak menulis apa pun
testCheck.answer=Menjawab:
testCheck.answer.yes=Benar
testCheck.answer.no=Salah
testCheck.answer.correct=Benar!
testCheck.answer.wrong=Salah!
testWrite.input.placeholder=Ketik jawaban Anda di sini
##
uknownPack.text=Mungkin kita pernah punya set ini sebelumnya... Sayangnya, sekarang sudah tidak tersedia lagi :(
packOnVerification.text=Paket ini akan tersedia untuk umum setelah verifikasi. Mohon tunggu.
##
packTest.form.questionLimit=Batasan pertanyaan
packTest.form.questionLimit.of=dari
packTest.form.questionLimit.invalid=Jumlah pertanyaan tidak valid.
packTest.form.questionWith=Pertanyaan dengan
packTest.form.questionWith.notSelected=Setidaknya satu opsi diperlukan.
packTest.form.requireOne=Hanya butuh satu jawaban
packTest.form.requireOne.explain=Diperlukan setidaknya satu jawaban yang benar. Jawaban harus dipisahkan dengan garis miring (/), koma (,), atau titik koma (;).
packTest.form.types=Jenis pertanyaan
packTest.form.types.notSelected=Setidaknya satu opsi diperlukan.
packTest.form.type.choice=Pilihan Ganda
packTest.form.type.yn=Benar/Salah
packTest.form.type.written=Tertulis
packTest.form.type.matching=Cocok
packTest.start=Mulai pengujian
packTest.qsMatching=Pertanyaan untuk pencocokan
packTest.qsMatching.expected=Jawaban yang benar adalah:
packTest.qsWritten=Pertanyaan untuk menulis
packTest.qsWritten.inputPlaceholder=ketik jawaban Anda di sini
packTest.qsWritten.expected=Jawaban yang benar adalah:
packTest.qsChoice=Pertanyaan untuk pilihan
packTest.qsChoice.expected=Jawaban yang benar adalah:
packTest.qsYN=Pertanyaan untuk benar/salah
packTest.qsYN.true=BENAR
packTest.qsYN.false=PALSU
packTest.qsYN.expected=Jawaban yang benar adalah:
packTest.checkAnswers=Periksa jawaban
packTest.score.prefix=Hasil pengujian:
packTest.score.90=Bagus sekali!
packTest.score.75=Bagus!
packTest.score.50=Rata-rata
packTest.score.25=Miskin
packTest.score.0=Lemah
##
columns.cardsInPack=Kartu
##
fexplorer.page.title={0} penjelajah kartu flash
fexplorer.page.categoryTitle={0} Kartu Flash
fexplorer.title=Penjelajah kartu flash
fexplorer.popularsCategories=Kategori populer
fexplorer.language=Bahasa saya
fexplorer.allCategories=Semua kategori
fexplorer.collections.section=Koleksi
fexplorer.flashcards.section=Kartu Flash
fexplorer.flashcards.terms=ketentuan
fexplorer.empty.message=Silakan pilih kategori <br>atau<br>
fexplorer.empty.search=Cari sesuatu
##
packPlay.progressBar.title=Kemajuan
packPlay.head.play=Kartu Flash
packPlay.head.learn=Mempelajari
packPlay.head.review=Tinjauan
packPlay.head.test=Tes
packPlay.head.write=Menulis
packPlay.head.memo=Memo
packPlay.head.spell=Mengeja
packPlay.head.match=Cocok
##
packMemo.showAnswer=Tunjukkan jawaban
packMemo.sessionComplete=Tidak ada lagi kartu<br>untuk hari ini!
packMemo.sessionNextTime=Kembali ke {0}.
packMemo.grades.button.H=Hampir tidak
packMemo.grades.button.E=Mudah
packMemo.grades.button.M=Sedang
packMemo.grades.button.1=Buruk
packMemo.grades.button.2=Lemah
packMemo.grades.button.3=Sedang
packMemo.grades.button.4=Bagus
packMemo.grades.button.5=Kuat
packMemo.grades.button.Y=Oke, aku ingat
packMemo.grades.button.R=Aku tahu
packMemo.grades.button.F=Saya tidak tahu
packMemo.short.days=h
packMemo.short.months=bu
packMemo.short.hours=j
packMemo.welcome.title=Meja Pembelajaran Jangka Panjang
packMemo.welcome.text=Ini adalah penjadwal pengulangan spasi. Setelah Anda memulai proses pembelajaran, Anda akan mempelajari 20 kartu setiap hari. Frekuensi kartu yang ditampilkan bergantung pada jawaban Anda. Mode ini didasarkan pada algoritma pengulangan spasi yang terkenal yang disebut SM-2. <br><a href="https://en.wikipedia.org/wiki/SuperMemo">Baca selengkapnya.</a>
packMemo.welcome.start=Ayo kita mulai
packMemo.welcome.login=Sayangnya, mode ini hanya tersedia untuk pengguna yang berwenang.<br>Silakan <a href="/login">masuk</a> atau <a href="/registration">daftar</a>. <br>Mudah dan sepenuhnya gratis.




packMemo.help.title=Petunjuk
packMemo.help.line1=SpaceBar untuk menampilkan jawaban
packMemo.help.line2=1,2,3,4,5 untuk menentukan pilihan Anda
packMemo.help.hide=Bersembunyi
packMemo.end.freshAvailable=Apakah Anda ingin melihat lebih banyak kartu baru hari ini?
packMemo.end.freshAccept=Ya, tunjukkan lebih banyak
##
fl.matchGame.welcome.text=Seret item satu sama lain untuk menghilangkannya
fl.matchGame.startGame=Mulai permainan
fl.matchGame.timer=Waktu
fl.matchGame.preset.number=Menghitung
fl.matchGame.result.title=Selamat!
fl.matchGame.result.text=Skor Anda {0} detik
fl.matchGame.result.again=Mainkan lagi
##
fl.memoHeatMap.title=Riwayat pembelajaran Anda
fl.memoHeatMap.legend.daverage=Rata-rata harian:
fl.memoHeatMap.legend.daverage.value={0} {0,plural,one{kartu}few{kartu-kartu}other{kartu-kartu}}
fl.memoHeatMap.legend.dlearned=Hari yang dipelajari:

fl.memoHeatMap.legend.beststreak=Rentetan terbaik:
fl.memoHeatMap.legend.beststreak.value={0} {0,plural,one{hari}few{hari}other{hari}}
fl.memoHeatMap.legend.currentstreak=Rentetan saat ini:
fl.memoHeatMap.legend.currentstreak.value={0} {0,plural,one{hari}few{hari}other{hari}}
fl.memoHeatMap.tooltip.passed={0} {0,plural,one{lulus tinjauan}few{ulasan yang lulus}other{ulasan yang lulus}}
fl.memoHeatMap.tooltip.failed={0} {0,plural,one{ulasan gagal}few{ulasan gagal}other{ulasan gagal}}
fl.memoHeatMap.tooltip.fresh={0} {0,plural,one{kartu baru}few{kartu baru}other{kartu baru}}
fl.memoHeatMap.tooltip.date=pada {0}
##
cardButtons.ban.title=Larang kartu ini
cardButtons.edit.title=Perbaiki kartu ini
cardButtons.star.title=Beralih kartu favorit
cardButtons.ban.prompt=Abaikan kartu ini?
##
validation.cardText.tooLong=Panjang maksimum teks ini adalah 1000 karakter
##
extLocale.la=Latin
extLocale.rw=Bahasa Kinyarwanda
extLocale.af=Afrikanas
extLocale.am=Bahasa Amharik
extLocale.az=orang Azerbaijan
extLocale.bn=Benggala
extLocale.bs=orang Bosnia
extLocale.ceb=Bahasa Cebu
extLocale.co=Korsika
extLocale.cy=Bahasa Wales
extLocale.eo=Esperanto
extLocale.eu=Bahasa Basque
extLocale.fa=Persia
extLocale.fy=Frisia
extLocale.gd=Skotlandia (Gaelik)
extLocale.gl=Galisia
extLocale.gu=Bahasa Gujarat
extLocale.ha=Rumah
extLocale.haw=orang Hawaii
extLocale.hmn=Bahasa Hmong
extLocale.ht=Kreol (Haiti)
extLocale.hy=Armenia
extLocale.id=Indonesia
extLocale.ig=Bahasa Igbo
extLocale.jw=Jawa
extLocale.ka=orang Georgia
extLocale.kk=Bahasa Kazakh
extLocale.km=Bahasa Khmer
extLocale.kn=Bahasa Kannada
extLocale.ku=Kurmanji
extLocale.ky=Kirgistan
extLocale.lb=Luksemburg
extLocale.lo=Bahasa Laos
extLocale.mg=Malagasi
extLocale.mi=Bahasa Maori
extLocale.ml=Bahasa Malayalam
extLocale.mn=orang Mongolia
extLocale.mr=Bahasa Marathi
extLocale.my=Birma
extLocale.ne=Bahasa Nepal
extLocale.ny=Ceva
extLocale.or=Oria
extLocale.pa=Bahasa Punjabi
extLocale.ps=Bahasa Pashtun
extLocale.sd=Bahasa Sindhi
extLocale.si=Bahasa Sinhala
extLocale.sm=Bahasa Samoa
extLocale.sn=Shona
extLocale.so=Somalia
extLocale.st=Bahasa Sesotho
extLocale.su=orang Sudan
extLocale.sw=Bahasa Swahili
extLocale.ta=Tamil
extLocale.te=Bahasa Telugu
extLocale.tg=Bahasa Tajik
extLocale.tk=Turkmen
extLocale.tl=Filipina
extLocale.tt=Bahasa Tatar
extLocale.ug=Uighur
extLocale.ur=Bahasa Urdu
extLocale.uz=Bahasa Uzbekistan
extLocale.xh=Bahasa Xhosa
extLocale.yi=Yiddi
extLocale.yo=Bahasa Yoruba
extLocale.zu=Bahasa Zulu


# landing
fl.landing.title=Belajar dengan {0}
fl.landing.title.small=Ketahui apa yang {0} dapat tambahkan ke proses pembelajaran Anda
fl.landing.why1.title=Mudah dan menyenangkan
fl.landing.why1.text=Ribuan anak sekolah dan siswa mengerjakan tugas {0} mereka setiap hari, meningkatkan nilai mereka. Di sofa, di kereta bawah tanah, di antrean - selalu ada beberapa menit untuk belajar.
fl.landing.why2.title=Enam mode pembelajaran
fl.landing.why2.text=Pilihlah alat yang paling sesuai dengan informasi yang perlu Anda pelajari.
fl.landing.why3.title=Pengulangan spasi
fl.landing.why3.text=Berdasarkan studi psikologi, metode pengulangan spasi memungkinkan Anda mengingat sejumlah besar informasi tanpa upaya ekstra. Lakukan saja selama 10-15 menit sehari.
fl.landing.why4.title=Di perangkat apa pun
fl.landing.why4.text=Bekerjalah di perangkat apa pun yang Anda miliki. Apa pun perangkatnya, komputer, tablet, atau ponsel - perangkat kami dioptimalkan untuk semuanya.
fl.landing.create.title=Buat set kartu Anda sendiri
fl.landing.create1.title=Menciptakan hafalan
fl.landing.create1.text=Untuk mempersiapkan satu set, Anda perlu menyusun dan menyederhanakan informasi. Ini adalah salah satu cara terbaik untuk menguasai materi. Di masa mendatang, Anda hanya perlu menyegarkan ingatan Anda.
fl.landing.create2.title=Impor yang nyaman
fl.landing.create2.text=Gunakan alat impor berkas teks yang fleksibel untuk memuat set dari sumber lain. Anda juga dapat mengimpor berkas ANKI.
fl.landing.create3.title=Memodifikasi
fl.landing.create3.text=Pilih satu set yang sesuai dari basis data kami, ubah dan tambahkan sesuai dengan kurikulum Anda.
fl.landing.create.button=Buat satu set
fl.landing.gallery=Contoh
fl.landing.gallery.others=Lihat contoh lainnya
fl.landing.stars1=3 juta<br>siswa setiap bulan
fl.landing.stars2=100.000.000+<br>sesi pelatihan
fl.landing.stars3=1000.000+<br>perlengkapan pendidikan
fl.landing.reg1=Bergabunglah sekarang dan gunakan kartu pendidikan latihan interval, koleksi pendidikan, dan dokumen pendidikan yang bermanfaat.
fl.landing.reg2=Tidak punya akun Google atau Facebook? Tidak masalah! Daftar dengan email Anda.
## fast add card










## uninstall page
fl_uninstall_title=Terima kasih telah menggunakan Studylib Extension.
fl_uninstall_subtitle=Kami turut prihatin atas kepergian Anda! Jika Anda punya waktu, beri tahu kami bagaimana kami dapat meningkatkan Extension:
fl_uninstall_notice=Umpan balik Anda membantu kami meningkatkan produk untuk semua orang, terima kasih 😊
fl_uninstall_button=Mengirim
fl_uninstall_success=Sampai berjumpa lagi!

## APPEND ITEMS ABOVE THIS LINE